import { useContext } from 'react';
import { FormikRefsContext } from '../contexts/CustomFormikContext';

export const useFormikRefs = () => {
	const context = useContext(FormikRefsContext);
	if (context === undefined) {
		throw new Error('FormikRefsContext is undefined');
	}
	return context;
};
